import { render, staticRenderFns } from "./admin-dropped-2024.vue?vue&type=template&id=4397ca7d&scoped=true"
import script from "./admin-dropped-2024.vue?vue&type=script&lang=js"
export * from "./admin-dropped-2024.vue?vue&type=script&lang=js"
import style0 from "./admin-dropped-2024.vue?vue&type=style&index=0&id=4397ca7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4397ca7d",
  null
  
)

export default component.exports